import useSafeState from "../utils/safe-state";
import {Button, Col, Form, Input, InputNumber, message, Row, Select, Spin, Tooltip} from "antd";
import React, {MutableRefObject, useEffect, useRef, useState} from "react";
import {Trans} from "@lingui/macro";
import {openNotification} from "../utils/openNotification";
import L from 'leaflet';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';

interface Interface{
    data?: any;
    mode?: 'Edit' | 'Add new';
}

const LocationDrawer = (props: Interface) => {

    const data = props.data || {};
    const [form] = Form.useForm();
      // Map refs
    const mapRef = useRef<HTMLDivElement | null>(null);
    const mapInstanceRef = useRef<L.Map | null>(null);
    const drawnItemsRef = useRef<L.FeatureGroup | null>(null);
    const drawControlRef = useRef<any>(null);
    const [currentGeoJSON, setCurrentGeoJSON] = useState(null);

    const [loading, setLoading] = useSafeState(false);

    const handleEdit = () => {};

    useEffect(() => {
        initializeMap();
    }, []);

    const initializeMap = () => {

        if (!mapRef.current || mapInstanceRef.current) return;

        try {
            const map = L.map(mapRef.current, {
                center: [47.5, 19.0], // Hungary center
                zoom: 7,
                zoomControl: true,
            });

            mapInstanceRef.current = map;

            // Add OpenStreetMap tiles
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '© OpenStreetMap contributors',
                maxZoom: 18,
            }).addTo(map);

            // Create feature group for drawn items
            const drawnItems = new L.FeatureGroup();
            map.addLayer(drawnItems);
            drawnItemsRef.current = drawnItems;

            // Add draw control
            const drawControl = new (L.Control as any).Draw({
                position: 'topright',
                draw: {
                    polygon: false,
                    rectangle: false,
                    circle: false,
                    circlemarker: false,
                    marker: false,
                    polyline: false,
                }
                // ,
                // edit: {
                //     featureGroup: drawnItems,
                //     remove: false
                // }
            });

            map.addControl(drawControl);

            // Handle draw events
      map.on('draw:created', (e) => {
        drawnItems.clearLayers();
        drawnItems.addLayer(e.layer);
        const geoJSON = e.layer.toGeoJSON();
        console.log(geoJSON);
        setCurrentGeoJSON(geoJSON);
        openNotification('success', 'Area drawn successfully')
      });

      map.on('draw:edited', (e:any) => {
        const layers = e.layers;
        layers.eachLayer((layer: any) => {
          const geoJSON = layer.toGeoJSON();
          setCurrentGeoJSON(geoJSON);
        });
          openNotification('success', 'Area updated successfully')
      });

      map.on('draw:deleted', () => {
        setCurrentGeoJSON(null);

          openNotification('success', 'Area cleared')
      });

      // Load existing geometry if available
        if (data && data.location) {
            loadExistingGeometry(map, drawnItems);
        }

      // Force resize
      setTimeout(() => {
        if (mapInstanceRef.current) {
            mapInstanceRef.current.invalidateSize();
        }
      }, 100);

    } catch (error) {
        console.error('Error initializing map:', error);
        openNotification('error', 'Failed to initialize map')
    }
  };

    const handleFinish = () => {}

    const loadExistingGeometry = (map: any, drawnItems: any) => {

        try {
            if (data.location) {
                // Try to parse as GeoJSON first, fallback to showing info
                let geoJSON;
                if (data.location.startsWith('{')) {
                    geoJSON = JSON.parse(data.location);
                } else {
                    // WKT format - show info but can't edit visually yet
                    openNotification('success', 'Existing geometry detected. You can draw a new one to replace it.');
                    return;
                }

                const layer = L.geoJSON(geoJSON, {
                    style: {
                        color: '#3388ff',
                        weight: 3,
                        fillOpacity: 0.2
                    }
                });

                drawnItems.addLayer(layer);
                setCurrentGeoJSON(geoJSON);

                // Fit map to geometry

                const bounds = layer.getBounds();
                if (bounds.isValid()) {
                    map.fitBounds(bounds, { padding: [20, 20] });
                }
            }
        } catch (error) {
            console.error('Error loading existing geometry:', error);
            openNotification('success', 'Could not load existing geometry for editing');
        }
    };


    const onReset = () => {
        form.resetFields();
    };

    return (
        <Form
            id="newLocation"
            layout='vertical'
            form={form}
            onFinish={() => (props.mode === 'Edit' ? handleEdit() : handleFinish())}
        >
            <>
                <Spin spinning={loading}></Spin>

                           <div
                             ref={mapRef}
                             style={{
                               height: '400px',
                               width: '100%',
                               border: '1px solid #d9d9d9',
                               borderRadius: '6px',
                               backgroundColor: '#f5f5f5'
                             }}
                           />
            </>
            <br/>
            {props.mode === 'Edit'
                ? (<Button disabled={true} hidden={true} htmlType="button" type="primary" onClick={() => form.submit()}>
                    <Trans>Save</Trans>
                </Button>)
                :
                <>
                    <Button hidden={true} htmlType="button" style={{ marginRight: 8 }} onClick={() => onReset()}>
                        <Trans>Vissza</Trans>
                    </Button>
                    <Button
                        hidden={true}
                        disabled={true}
                        loading={loading}
                        htmlType="button"
                        type="primary"
                        style={{ marginRight: 8 }}
                        onClick={() => form.submit()}
                    >
                        <Trans>Save</Trans>
                    </Button>
                </>
            }
        </Form>
    );

}
export default LocationDrawer;
